import React from "react";
import { COMPANY, WHATSAPP_URL } from "../lib/content";

export default function WhatsAppFloat() {
  return (
    <a
      href={WHATSAPP_URL("Olá, gostaria de uma avaliação técnica de obra com a SCA.")}
      target="_blank"
      rel="noreferrer"
      aria-label={`Falar com a SCA Construtora no WhatsApp ${COMPANY.whatsapp}`}
      data-testid="whatsapp-float-button"
      className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-40 group"
    >
      <span className="relative flex items-center justify-center w-16 h-16 md:w-[68px] md:h-[68px]">
        {/* Pulsing rings */}
        <span
          className="absolute inset-0 rounded-full bg-[#25D366]/55 animate-pulse-ring"
          aria-hidden
        />
        <span
          className="absolute inset-0 rounded-full bg-[#25D366]/40 animate-pulse-ring"
          style={{ animationDelay: "0.6s" }}
          aria-hidden
        />
        {/* Solid button */}
        <span className="relative flex items-center justify-center w-16 h-16 md:w-[68px] md:h-[68px] rounded-full bg-[#25D366] text-white shadow-[0_14px_34px_-10px_rgba(37,211,102,0.75)] hover:bg-[#1ebc59] transition-colors duration-300 group-hover:scale-105 ease-out">
          <svg viewBox="0 0 24 24" className="w-8 h-8 md:w-9 md:h-9 drop-shadow-sm" fill="currentColor" aria-hidden>
            <path d="M19.05 4.91A9.82 9.82 0 0 0 12.04 2C6.58 2 2.13 6.45 2.13 11.92c0 2.1.55 4.15 1.6 5.96L2 22l4.25-1.65a9.9 9.9 0 0 0 5.78 1.84h.01c5.46 0 9.91-4.45 9.91-9.92 0-2.65-1.03-5.14-2.9-7.36ZM12.04 20.3a8.2 8.2 0 0 1-4.19-1.15l-.3-.18-2.52.98.86-2.45-.2-.32a8.27 8.27 0 1 1 6.35 3.12Zm4.52-6.18c-.25-.13-1.47-.72-1.69-.81-.23-.08-.39-.13-.56.13-.17.25-.65.81-.79.97-.15.17-.29.19-.54.06-.25-.13-1.05-.39-2-1.23-.74-.66-1.24-1.47-1.38-1.72-.15-.25-.02-.39.11-.51.11-.11.25-.29.37-.43.13-.15.17-.25.25-.42.08-.17.04-.31-.02-.43-.06-.13-.56-1.35-.77-1.85-.2-.49-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.23.25-.86.84-.86 2.05 0 1.21.88 2.38 1 2.55.13.17 1.74 2.66 4.21 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.55.1.47-.07 1.47-.6 1.68-1.18.21-.59.21-1.09.15-1.18-.06-.1-.23-.16-.49-.29Z" />
          </svg>
        </span>
      </span>
      {/* Tooltip */}
      <span className="absolute right-full top-1/2 -translate-y-1/2 mr-3 hidden md:flex items-center gap-1 px-3 py-2 bg-sca-black text-white text-[11px] tracking-[0.18em] uppercase font-bold whitespace-nowrap opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
        Fale conosco
      </span>
    </a>
  );
}
